// After sign-in a user returns only to an internal page; another origin, a
// protocol-relative or malformed value, or an auth page itself falls back to home.
const AUTH_PAGES = ['/login', '/register', '/pending'];
const BASE = 'http://internal.invalid';

export function safeReturnTo(value) {
  if (typeof value !== 'string' || value.length > 2048 || !value.startsWith('/')) return null;
  if (value.startsWith('//') || value.includes('\\')) return null;
  if ([...value].some((ch) => ch.charCodeAt(0) <= 0x1f || ch.charCodeAt(0) === 0x7f)) return null;
  let url;
  try { url = new URL(value, BASE); } catch { return null; }
  // Dot segments can normalize into a protocol-relative path (/a/..//host), so check after parsing.
  if (url.origin !== BASE || url.pathname.startsWith('//')) return null;
  // The router matches decoded paths case-insensitively, so /LOGIN and /%6cogin are auth pages too.
  let decoded;
  try { decoded = decodeURIComponent(url.pathname).toLowerCase(); } catch { return null; }
  if (AUTH_PAGES.some((page) => decoded === page || decoded.startsWith(`${page}/`))) return null;
  return `${url.pathname}${url.search}${url.hash}`;
}

// Router state carried to /login so the page asked for survives the sign-in.
export function returnState(location) {
  const from = safeReturnTo(`${location?.pathname || ''}${location?.search || ''}${location?.hash || ''}`);
  return from ? { from } : undefined;
}
